module.exports = __webpack_public_path__ + "img/wedding-02.efd808cd.jpg";